import { useDispatch, useSelector } from "react-redux";
import { selectIsLoggedIn } from "../../../redux/features/auth/authSlice";
import { useEffect, useState } from "react";
import {
  deletePost,
  getPosts,
  togglePublish,
} from "../../../redux/features/post/postSlice";
import Search from "../../search/Search";
import { Spinner } from "../../loader/Loader";
import { AiOutlineEye } from "react-icons/ai";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";
import { shortenText } from "../../../utils";
import ReactPaginate from "react-paginate";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import {
  FILTER_BY_SEARCH,
  selectFilteredPosts,
} from "../../../redux/features/post/filterSlice";
import Loader from "../../newsApi/Loader";

const ViewPosts = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { posts, isLoading } = useSelector((state) => state.post);
  const filteredPosts = useSelector(selectFilteredPosts);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getPosts());
    }
  }, [isLoggedIn, dispatch]);

  const confirmDelete = (id) => {
    confirmAlert({
      title: "Delete Product",
      message: "Are you sure to delete this post?.",
      buttons: [
        {
          label: "Delete",
          onClick: () => delPost(id),
        },
        {
          label: "Cancel",
          //  onClick: () => alert("Click No"),
        },
      ],
    });
  };

  const delPost = async (id) => {
    await dispatch(deletePost(id));
    await dispatch(getPosts());
  };

  // Begin Pagination
  const itemsPerPage = 6;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = filteredPosts.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(posts.length / itemsPerPage);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % posts.length;
    setItemOffset(newOffset);
  };

  //  End Pagination

  useEffect(() => {
    dispatch(FILTER_BY_SEARCH({ posts, search }));
  }, [posts, search, dispatch]);

  return (
    <section>
      <div className="container product-list">
        <div className="table">
          <div className="--flex-between --flex-dir-column">
            <span>
              <h2>All Products</h2>
              <p>
                ~ <b>{filteredPosts.length}</b> Posts found
              </p>
            </span>
            <span>
              <Search
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </span>
          </div>
        </div>

        {/* {isLoading && <Spinner />} */}
        {isLoading && <Loader />}

        <div className="table">
          {!isLoading && posts.length === 0 ? (
            <p>No post found...</p>
          ) : (
            <table>
              <thead>
                <td>s/n</td>
                <td>Title</td>
                <td>Category</td>
                <td>Views</td>
                <td>Action</td>
              </thead>

              <tbody>
                {currentItems?.map((post, index) => {
                  const { _id, title, category, isPublished, views } = post;
                  return (
                    <tr key={_id}>
                      <td>{itemOffset + index + 1}</td>
                      <td>{shortenText(title, 16)}</td>
                      <td>{category}</td>
                      <td>{views}</td>

                      <td className="icons">
                        <span>
                          <Link to="/">
                            <AiOutlineEye size={25} color={"purple"} />
                          </Link>
                        </span>
                        <span>
                          <Link to={`/admin/edit-post/${_id}`}>
                            <FaEdit size={20} color={"green"} />
                          </Link>
                        </span>
                        <span>
                          <FaTrash
                            size={20}
                            color={"red"}
                            onClick={() => confirmDelete(_id)}
                          />
                        </span>

                        <span>
                          <button
                            onClick={async () => {
                              await dispatch(togglePublish(_id));
                              dispatch(getPosts()); // refresh posts after toggle
                            }}
                            className="--btn --btn-sm"
                            style={{
                              backgroundColor: isPublished
                                ? "#ff8800"
                                : "#00c851",
                              color: "#fff",
                              marginLeft: "5px",
                            }}
                          >
                            {isPublished ? "Unpublish" : "Publish"}
                          </button>
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
        <ReactPaginate
          breakLabel="..."
          nextLabel="Next"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="Prev"
          renderOnZeroPageCount={null}
          containerClassName="pagination"
          pageLinkClassName="page-num"
          previousLinkClassName="page-num"
          nextLinkClassName="page-num"
          activeLinkClassName="activePage"
        />
      </div>
    </section>
  );
};
export default ViewPosts;
